import { supabase } from "@/integrations/supabase/client";
import { FunctionsHttpError } from "@supabase/supabase-js";

let running: Promise<void> | null = null;
/** Share a single sync across admin views; the server paginates and serializes provider calls. */
export function syncLexwareInvoices(): Promise<void> {
  if (running) return running;
  running = (async () => {
    let afterId: string | undefined;
    do {
      const { data, error } = await supabase.functions.invoke("lexware-invoice-status", { body: { action: "sync", afterId } });
      if (error) {
        const details = error instanceof FunctionsHttpError ? await error.context.text() : error.message;
        throw new Error(details);
      }
      if (data.errors?.length) throw new Error(data.errors.map((e: { error: string }) => e.error).join("; "));
      afterId = data.nextCursor ?? undefined;
    } while (afterId);
  })().finally(() => { running = null; });
  return running;
}